import React from "react";
import Signin from "../components/onboard/Signin";
import HomeBtn from "../components/common/HomeBtn";

const Login = () => {
  return (
    <>
      <HomeBtn />
      <Signin />
    </>
  );
};

export default Login;
